import ValuationPageComponent from './ValuationPageView.jsx';

export default ValuationPageComponent;
